import {h} from 'preact';

export default ({name, value, updateValue, required = false}) => {
    const onInput = e => updateValue(e.currentTarget.value);

    const optionalProps = {};

    if (required) {
        optionalProps.required = 'required';
    }

    return (
        <div className={[
                "formField",
                "formField--textInput",
                value.length && "formField--filled"
            ].filter(i => i).join(' ')}
        >
            <input
                type="text"
                className="textInput"
                autocomplete="off"
                name={name}
                value={value}
                onInput={onInput}
                onChange={onInput}
                {...optionalProps}
            />
            <label for={name}>
                PLZ der Schule eingeben {required && '*'}
            </label>
        </div>
    );
};
